import React, { useRef } from "react";
import TextField from "@material-ui/core/TextField";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import SendIcon from "@material-ui/icons/Send";
import Button from "@material-ui/core/Button";
import { InputBase, Link, Tooltip, Typography } from "@material-ui/core";
import AttachFileIcon from "@material-ui/icons/AttachFile";

const useStyles = makeStyles((theme) =>
  createStyles({
    wrapForm: {
      display: "flex",
      justifyContent: "center",
      width: "100%",
      margin: `${theme.spacing(0)} auto`,
      paddingLeft: "10px",
      paddingRight: "10px",
      height: "50px",
    },
    wrapText: {
      width: "100%",
    },
    button: {
      //margin: theme.spacing(1),
      backgroundColor: "#b499c7",
      height: "50px",
    },
    input: {
      border: "2px solid rgba(0,0,0,0.2)",
      padding: "4px 10px",
      fontSize: "20px !important",
      height: "120px",
      borderRadius: "8px",
      marginRight: "10px",
    },
    input2: {
      display: "none",
    },
    tooltip: {
      backgroundColor: "rgba(118,95,170,1)",
      padding: "10px",
      maxWidth: "none",
    },
    tooltipArrow: {
      backgroundColor: "rgba(118,95,170,1)",
    },
  })
);

export const TextInput = (props) => {
  const classes = useStyles();
  const inputRef = useRef(null);
  return (
    <>
      <form className={classes.wrapForm} noValidate autoComplete="off">
        {props?.file?.type?.match("image")?.input ? (
          <img
            style={{
              height: "120px",
              width: "120px",
              maxWidth: "none",
              objectFit: "contain",
              marginRight: "10px",
            }}
            src={URL.createObjectURL(props.file)}
          />
        ) : (
          <Typography
            style={{
              fontSize: "18px",
              fontFamily: "Montserrat",
              fontWeight: 700,
              width: props?.file?.name ? "35%" : "auto",
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
              paddingLeft: "5px",
              paddingRight: "5px",
            }}
          >
            <Link onClick={() => {}}>{props?.file?.name}</Link>
          </Typography>
        )}
        <InputBase
          id="standard-text"
          placeholder="Send Message"
          fullWidth
          value={props.inputValue}
          onChange={(e) => props.setInputValue(e.target.value)}
          multiline
          rows={4}
          maxRows={4}
          className={classes.input}
          onKeyDown={(e) => {
            if (e.key == "Enter") {
              props.onSubmitMessage();
            }
          }}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "120px",
          }}
        >
          <Tooltip
            classes={{
              tooltip: classes.tooltip,
              tooltipArrow: classes.tooltipArrow,
            }}
            PopperProps={{
              disablePortal: true,
            }}
            placement="left"
            arrow
            title={
              <Typography
                style={{
                  fontFamily: "Montserrat",
                  fontSize: "16px",
                  color: "#fff",
                  fontWeight: "bold",
                }}
              >
                Attach File
              </Typography>
            }
          >
            <Button
              onClick={() => inputRef.current.click()}
              variant="contained"
              className={classes.button}
            >
              <AttachFileIcon
                style={{ transform: "rotate(-40deg)", color: "white" }}
              />
            </Button>
          </Tooltip>
          <Tooltip
            classes={{
              tooltip: classes.tooltip,
              tooltipArrow: classes.tooltipArrow,
            }}
            PopperProps={{
              disablePortal: true,
            }}
            placement="left"
            arrow
            title={
              <Typography
                style={{
                  fontFamily: "Montserrat",
                  fontSize: "16px",
                  color: "#fff",
                  fontWeight: "bold",
                }}
              >
                Send Message
              </Typography>
            }
          >
            <Button
              onClick={() => props.onSubmitMessage()}
              variant="contained"
              className={classes.button}
            >
              <SendIcon
                style={{ transform: "rotate(-40deg)", color: "white" }}
              />
            </Button>
          </Tooltip>

          <input
            type="file"
            accept="image/png, image/jpeg,application/pdf,video/mp4"
            id="icon-button-photo"
            name="icon-button-photo"
            onChange={props.onAttachFile}
            hidden
            ref={inputRef}
          />
        </div>
      </form>
    </>
  );
};
